module.exports = __webpack_public_path__ + "img/guide_vi.bc84c2f.png";